__turbopack_context__.v({
  "danger": "RectButton-module__uBkGUa__danger",
  "dark": "RectButton-module__uBkGUa__dark",
  "fullWidth": "RectButton-module__uBkGUa__fullWidth",
  "ghost": "RectButton-module__uBkGUa__ghost",
  "outlined": "RectButton-module__uBkGUa__outlined",
  "primary": "RectButton-module__uBkGUa__primary",
  "rectButton": "RectButton-module__uBkGUa__rectButton",
  "secondary": "RectButton-module__uBkGUa__secondary",
});
